import { ChangeDetectorRef, Component } from '@angular/core';
import { LoaderService } from './services/common/loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'transportemaritimo2';
  loading: boolean = false;

  constructor(
    private loaderService: LoaderService,
    private cdRef: ChangeDetectorRef,
  ) {}

  ngOnInit() {
  }

  ngAfterViewChecked() {
    this.loaderService.status.subscribe((val: boolean) => {
      this.loading = val;
    });
    this.cdRef.detectChanges();
  }
}
